import React from 'react';
import { Container } from 'react-bootstrap';
import DiaNaoAgendarCadastro from './DiaNaoAgendarCadastro';

const DiaNaoAgendarGlobal: React.FC = () => {
  return (
    <Container fluid className="mt-2">
      <div className="bg-white border p-2 mb-2">
        <div className="d-flex justify-content-between mb-2">
          <h2 id="topoBusca">Dia Não Agendar Global</h2>
        </div>
        <p>
          Adicione feriados, recessos e outros dias em que a clínica não terá
          atendimento. As datas cadastradas aqui bloquearão automaticamente
          todas as agendas
        </p>
        <DiaNaoAgendarCadastro conCodigo={0} />
      </div>
    </Container>
  );
};

export default DiaNaoAgendarGlobal;
